import React from 'react';
import Link from 'next/link';
import NProgress, { set } from 'nprogress';
import { validateEmail } from 'avilatek-utils';
import { useMutation } from '@apollo/client';
import { Input } from '@avila-tek/ui/src/input/Input';
import { RESET_PASSWORD } from '../../graphql/mutation';
import { useNotify } from '../../hooks';
import Button from '../shared/Button/Button';

function RecoverForm() {
  // const router = useRouter();
  const notify = useNotify();
  const [email, setEmail] = React.useState('');
  // const [user, setUser] = useUser();
  const [recoverPassword] = useMutation<{
    resetPassword: {
      err: string;
      success: boolean;
    };
  }>(RESET_PASSWORD);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault();
      NProgress.start();
      // Checking email
      if (!validateEmail(email)) {
        notify('Su correo electrónico es inválido', 'error');
        return;
      }
      const { data } = await recoverPassword({
        variables: {
          data: {
            email: email.toLowerCase().trim(),
          },
        },
      });
      if (data?.resetPassword?.success) {
        notify(
          'Se ha enviado un correo electrónico para recuperar su contraseña',
          'success'
        );
        setEmail('');
      } else {
        notify(
          'Ha ocurrido un error al recuperar su contraseña, por favor intente de nuevo',
          'error'
        );
      }
    } catch (err) {
      notify(err.message, 'error');
      console.log(err);
    } finally {
      NProgress.done();
    }
  };

  return (
    <>
      <h2 className="text-xl text-center sm:text-3xl text-text-black font-semibold mx-auto ">
        Recuperar contraseña
      </h2>
      <span className="text-sm sm:text-base text-center text-text-black">
        Ingrese su correo electrónico para recuperar su contraseña en Meit!
      </span>
      <form
        className="space-y-5 flex flex-col text-gray-300"
        onSubmit={onSubmit}
      >
        <span className="block text-sm font-medium text-slate-700">
          Correo electrónico
        </span>
        <Input
          placeholder="Ingrese su correo electrónico"
          required
          className="border border-gray-300 text-gray-300"
          type="text"
          id="email"
          value={email}
          onChange={(e) => {
            e.preventDefault();
            setEmail(e.target.value);
          }}
        />
        <Link href="/sign-in">
          <div className="text-color-primary-text-300 w-full text-right cursor-pointer">
            ¿Quieres volver para iniciar sesión?
          </div>
        </Link>
        <Button>Recuperar contraseña</Button>
      </form>
    </>
  );
}

export default RecoverForm;
